import * as React from 'react';

import Security32 from './Security32';

export const security32 = () => <Security32 />;

export default {
    title: 'Icon/Logo/Security32',
    component: Security32,
    parameters: {
        notes: "`import Security32 from 'box-ui-elements/es/icon/logo/Security32';`",
    },
};
